// src/createParagraphPlugin.ts
import {
  createPluginFactory,
  onKeyDownToggleElement
} from "@udecode/plate-common/server";
var ELEMENT_PARAGRAPH = "p";
var createParagraphPlugin = createPluginFactory({
  deserializeHtml: {
    query: (el) => el.style.fontFamily !== "Consolas",
    rules: [
      {
        validNodeName: "P"
      }
    ]
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement
  },
  isElement: true,
  key: ELEMENT_PARAGRAPH,
  options: {
    hotkey: ["mod+opt+0", "mod+shift+0"]
  }
});
export {
  ELEMENT_PARAGRAPH,
  createParagraphPlugin
};
//# sourceMappingURL=index.mjs.map